export default "__VITE_ASSET__fbff4b46__"